<template>
  <div class="balance">
    <div class="balance-wrapper">
      <div class="left" :class="{ 'full': external }">
        <p class="budget" v-if="inquiry.part._id">
          Предвиден бюджет за част "{{ inquiry.part._id }}"
        </p>
        <div
          class="table-wrapper"
          :class="{ 'table-wrapper--disabled': !showWorkers }"
        >
          <table>
            <thead>
              <tr>
                <th>Труд</th>
                <th>Бр. отчитания</th>
                <th>Изработени часове</th>
                <th>Ставка (€/час)</th>
                <th>Сума (€)</th>
              </tr>
            </thead>
            <tbody v-if="showWorkers">
              <tr v-for="(p, i) in positions" :key="`positions-${i}`">
                <td>{{ p._id.name }}</td>
                <td>{{ p.instances }}</td>
                <td>{{ p.totalHours }}</td>
                <td>{{ p._id.rate }}</td>
                <td>
                  <strong>{{ p.total.toFixed(2) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="tr-total">
                    <span>Обща сума:</span>
                    <span>{{ totalPositions.toFixed(2) }}</span>
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="td--disabled">
                  Трудът временно е изключен от справката.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="table-wrapper"
          :class="{ 'table-wrapper--disabled': !showMechanizations }"
        >
          <table>
            <thead>
              <tr>
                <th>Собствена механизация</th>
                <th>Бр. отчитания</th>
                <th>Изработени МСМ</th>
                <th>Цена (€/МСМ)</th>
                <th>Сума (€)</th>
              </tr>
            </thead>
            <tbody v-if="showMechanizations">
              <tr v-for="(m, i) in mechanizations" :key="`mechanizations-${i}`">
                <td>{{ m._id.name }}</td>
                <td>{{ m.instances }}</td>
                <td>{{ m.items }}</td>
                <td>{{ m._id.price }}</td>
                <td>
                  <strong>{{ m.total.toFixed(2) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="tr-total">
                    <span>Обща сума:</span>
                    <span>{{ totalMechanizations.toFixed(2) }}</span>
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="td--disabled">
                  Собствената механизация временно е изключена от справката.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="table-wrapper"
          :class="{ 'table-wrapper--disabled': !showTools }"
        >
          <table>
            <thead>
              <tr>
                <th>Инвентар</th>
                <th>Бр. отчитания</th>
                <th>Изработени МСМ</th>
                <th>Цена (€/МСМ)</th>
                <th>Сума (€)</th>
              </tr>
            </thead>
            <tbody v-if="showTools">
              <tr v-for="(m, i) in tools" :key="`mechanizations-${i}`">
                <td>{{ m._id.name }}</td>
                <td>{{ m.instances }}</td>
                <td>{{ m.items }}</td>
                <td>{{ m._id.price }}</td>
                <td>
                  <strong>{{ m.total.toFixed(2) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="tr-total">
                    <span>Обща сума:</span>
                    <span>{{ totalTools.toFixed(2) }}</span>
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="td--disabled">
                  Инструментите са временно изключени от справката.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="table-wrapper"
          :class="{ 'table-wrapper--disabled': !showRentedMechanizations }"
        >
          <table>
            <thead>
              <tr>
                <th>Наета механизация</th>
                <th>Бр. отчитания</th>
                <th>Изработени МСМ</th>
                <th>Цена (€/МСМ)</th>
                <th>Сума (€)</th>
              </tr>
            </thead>
            <tbody v-if="showRentedMechanizations">
              <tr v-for="(m, i) in rentedMechanizations" :key="`rentedMechanizations-${i}`">
                <td>{{ m._id.name }}</td>
                <td>{{ m.instances }}</td>
                <td>{{ m.items }}</td>
                <td>{{ m._id.price }}</td>
                <td>
                  <strong>{{ m.total.toFixed(2) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="tr-total">
                    <span>Обща сума:</span>
                    <span>{{ totalRentedMechanizations.toFixed(2) }}</span>
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="td--disabled">
                  Наетата механизация временно е изключена от справката.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="table-wrapper"
          :class="{ 'table-wrapper--disabled': !showMaterials }"
        >
          <table>
            <thead>
              <tr>
                <th>Материали</th>
                <th>Бр. отчитания</th>
                <th>Изработени количества</th>
                <th>Ед. цена (€)</th>
                <th>Сума (€)</th>
              </tr>
            </thead>
            <tbody v-if="showMaterials">
              <tr v-for="(m, i) in materials" :key="`materials-${i}`">
                <td>{{ m._id.name }}</td>
                <td>{{ m.instances }}</td>
                <td>{{ m.items }} {{ m.unit }}</td>
                <td>{{ m._id.price }}</td>
                <td>
                  <strong>{{ m.total.toFixed(2) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="tr-total">
                    <span>Обща сума:</span>
                    <span>{{ totalMaterials.toFixed(2) }}</span>
                  </p>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="td--disabled">
                  Материалите временно са изключени от справката.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="totals">
          <span>Обща сума разходи:</span>
          <span
            >{{
              (totalPositions + totalMechanizations + totalTools + totalRentedMechanizations + totalMaterials).toFixed(2)
            }}
            €</span
          >
        </p>
        <p class="totals" v-if="inquiry.part._id">
          <span>Използван бюджет</span>
          <span
            >{{
              budget
                ? (
                    ((totalPositions + totalMechanizations + totalTools + totalRentedMechanizations + totalMaterials) /
                      budget) *
                    100
                  ).toFixed(2)
                : '0'
            }}
            %</span
          >
        </p>
      </div>
      <div class="right" v-if="!external">
        <p class="budget" v-if="inquiry.part._id">
          {{ budget.toFixed(2) }} €
        </p>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Дейности</th>
                <th>Бр. отчитания</th>
                <th>Изработени количества</th>
                <th>Ед. цена (€)</th>
                <th>Сума (€)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(a, i) in activities" :key="`activities-${i}`">
                <td>{{ a._id.name }}</td>
                <td>{{ a.instances }}</td>
                <td>{{ a.items }} {{ a.unit }}</td>
                <td>{{ a._id.price }}</td>
                <td>
                  <strong>{{ a.total.toFixed(2) }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <p class="tr-total">
                    <span>Обща сума:</span>
                    <span>{{ totalActivities.toFixed(2) }}</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="totals">
          <span>Обща сума приходи:</span>
          <span>{{ totalActivities.toFixed(2) }} €</span>
        </p>
        <p class="totals" v-if="inquiry.part._id">
          <span>Приходи до момента</span>
          <span
            >{{
              budget ? ((totalActivities / budget) * 100).toFixed(2) : '0'
            }}
            %</span
          >
        </p>
      </div>
    </div>
    <p class="totals" v-if="!external">
      <span>БАЛАНС:</span>
      <span
        >{{
          (
            totalActivities -
            (totalPositions + totalMechanizations + totalTools + totalRentedMechanizations + totalMaterials)
          ).toFixed(2)
        }}
        €</span
      >
    </p>
  </div>
</template>

<script>
import hours from './mixins/hours';
export default {
  mixins: [hours],
  props: [
    'inquiry',
    'isInquiryMade',
    'activeProjects',
    'showWorkers',
    'showMaterials',
    'showMechanizations',
    'showTools',
    'showRentedMechanizations',
    'external'
  ],
  watch: {
    isInquiryMade(to) {
      if (to) {
        this.getData();
      }
    },
  },
  data() {
    return {
      positions: [],
      mechanizations: [],
      tools: [],
      rentedMechanizations: [],
      materials: [],
      activities: [],
      totalPositions: 0,
      totalMechanizations: 0,
      totalTools: 0,
      totalRentedMechanizations: 0,
      totalMaterials: 0,
      totalActivities: 0,
      budget: 0,
    };
  },
  methods: {
    getData() {
      if (this.inquiry.worker._id) {
        return;
      }
      // this.$store.dispatch('startLoading');

      this.positions = [];
      this.mechanizations = [];
      this.tools = [];
      this.rentedMechanizations = [];
      this.materials = [];
      this.activities = [];
      this.totalPositions = 0;
      this.totalMechanizations = 0;
      this.totalTools = 0;
      this.totalRentedMechanizations = 0;
      this.totalMaterials = 0;
      this.totalActivities = 0;
      this.budget = 0;

      let url = `${process.env.VUE_APP_BASE_URI}/balance`;

      url += `?from=${this.inquiry.fromDate ? this.inquiry.fromDate.toISOString() : ''}`;
      url += `&to=${this.inquiry.toDate ? this.inquiry.toDate.toISOString() : ''}`;

      if (this.inquiry.company._id) {
        url += `&company=${this.inquiry.company._id}`;
      }
      if (this.inquiry.project._id) {
        url += `&project=${this.inquiry.project._id}`;
      }
      if (this.inquiry.part._id) {
        url += `&part=${encodeURIComponent(this.inquiry.part._id)}`;
      }
      if (this.inquiry.reporter._id) {
        url += `&reporter=${this.inquiry.reporter._id}`;
      }
      if (this.inquiry.isInvalid) {
        url += `&invalid=${this.inquiry.isInvalid}`;
      }
      if (this.inquiry.isPlanned) {
        url += `&planned=${this.inquiry.isPlanned}`;
      }
      if (this.activeProjects) {
        url += `&active=${this.activeProjects}`;
      }

      if (this.showWorkers) {
        this.$http.get(`${url}&type=positions`).then((response) => {
          this.positions = response.data;
          this.positions.forEach((p) => {
            p.totalHours = 0;
            p.hours.forEach((h) => {
              p.totalHours += this.calculateHours(h.date, h.from, h.to).total;
            });
            p.total = p.totalHours * p._id.rate;
            delete p.hours;

            this.totalPositions += p.total;
          });
        });
      }
      if (this.showMechanizations) {
        this.$http.get(`${url}&type=mechanizations`).then((response) => {
          this.mechanizations = response.data;

          this.mechanizations.forEach((m) => {
            this.totalMechanizations += m.total;
          });
        });
      }
      if (this.showTools) {
        this.$http.get(`${url}&type=tools`).then((response) => {
          this.tools = response.data;

          this.tools.forEach((m) => {
            this.totalTools += m.total;
          });
        });
      }
      if (this.showRentedMechanizations) {
        this.$http.get(`${url}&type=rentedMechanizations`).then((response) => {
          this.rentedMechanizations = response.data;

          this.rentedMechanizations.forEach((m) => {
            this.totalRentedMechanizations += m.total;
          });
        });
      }
      if (this.showMaterials) {
        this.$http.get(`${url}&type=materials`).then((response) => {
          this.materials = response.data;

          this.materials.forEach((m) => {
            this.totalMaterials += m.total;
          });
        });
      }

      if (this.inquiry.part._id) {
        url += '&budget=true';
      }

      this.$http.get(`${url}&type=activities`).then((response) => {
        if (this.inquiry.part._id) {
          this.activities = response.data.list;
          this.budget = response.data.budget;
        } else {
          this.activities = response.data;
        }

        this.activities.forEach((a) => {
          this.totalActivities += a.total;
        });
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.balance-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}
.left,
.right {
  display: flex;
  flex-direction: column;
  height: 70vh;
  width: calc(50% - 5px);
}
.left.full {
  width: 100%;
}
.left > .budget,
.right > .budget {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}
.right > .budget {
  text-align: right;
}
.totals {
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
}
.totals ~ .totals {
  font-size: 18px;
  /* padding-bottom: 0; */
  padding-top: 0;
}
.balance > .totals {
  background-color: #b9b9b9;
  border-radius: 4px;
  margin-bottom: 10px;
}
.table-wrapper {
  border-radius: 4px;
  height: 50%;
  margin-bottom: 10px;
  overflow: auto;
  width: 100%;
}
.table-wrapper table {
  border-collapse: collapse;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
}
.table-wrapper th,
.table-wrapper td {
  font-size: 11px;
  line-height: 11px;
  padding: 10px 20px;
  text-align: right;
}
.table-wrapper th {
  height: 30px;
}
.table-wrapper th:first-child,
.table-wrapper td:first-child {
  text-align: left;
}
.left .totals {
  color: #ae0015;
}
.left .table-wrapper {
  background-color: #fadbd2;
}
.left .table-wrapper th {
  background-color: #f5b7a6;
}
.left .table-wrapper--disabled table {
  height: 100%;
}
.left .table-wrapper--disabled {
  background-color: rgba(218, 218, 218, 0.5);
}
.left .table-wrapper--disabled th {
  background-color: rgba(228, 228, 228, 0.5);
}
.table-wrapper td.td--disabled {
  color: rgba(55, 55, 55, 0.5);
  font-size: 14px;
  text-align: center;
}
.right .totals {
  color: #387403;
}
.right .table-wrapper {
  background-color: #e2efd9;
  height: 100%;
}
.right .table-wrapper th {
  background-color: #c5e0b3;
}
.tr-total {
  border-top: 1px solid #f5b7a6;
  display: flex;
  font-weight: 700;
  justify-content: space-between;
  padding: 15px 0;
}
.left .table-wrapper--disabled .tr-total {
  border-top: 1px solid transparent;
}
.right .tr-total {
  border-top: 1px solid #c5e0b3;
}
</style>
